(function () {
  'use strict';

  var mergePromise = null;
  var MAX_SPACES = 72;

  function readJson(key, fallback) {
    try { var value = JSON.parse(localStorage.getItem(key) || 'null'); return value == null ? fallback : value; }
    catch (_) { return fallback; }
  }

  function sourceType(item) {
    return item && (item.sourceType === 'upload' || item.sourceType === 'text') ? item.sourceType : 'library';
  }

  function itemIdentity(item) {
    if (!item || typeof item !== 'object') return '';
    var type = sourceType(item);
    if (type === 'library') {
      var productId = String(item.productId || '').trim();
      var numericProductId = productId.match(/(?:Product\/)?(\d+)$/i);
      if (productId) return 'library:product:' + (numericProductId ? numericProductId[1] : productId.toLowerCase());
      if (item.productHandle) return 'library:handle:' + String(item.productHandle).trim().toLowerCase();
      if (item.designCode) return 'library:code:' + String(item.designCode).trim().toLowerCase();
      return 'library:item:' + String(item.id || '').trim();
    }
    if (type === 'text') return 'text:' + String(item.id || '').trim();
    return 'upload:' + String(item.id || item.localAssetId || '').trim();
  }

  function savedAliases(item) {
    if (!item || typeof item !== 'object') item = { handle: item };
    var handle = String(item.handle || '').trim().toLowerCase();
    var productGid = String(item.productGid || item.product_gid || (item.productId ? 'gid://shopify/Product/' + String(item.productId).replace(/\D/g, '') : '')).trim();
    var unit = String(item.designUnitId || item.design_unit_id || '').trim();
    var code = String(item.code || '').trim();
    return [productGid, unit && 'unit:' + unit, code && 'code:' + code, String(item.legacyDesignId || item.legacy_design_id || '').trim(), handle && 'handle:' + handle, String(item.designId || item.design_id || '').trim()].filter(Boolean);
  }

  function unionSaved() {
    var output = [];
    Array.prototype.slice.call(arguments).forEach(function (records) {
      (Array.isArray(records) ? records : []).forEach(function (record) {
        var aliases = savedAliases(record);
        if (!aliases.length) return;
        var index = output.findIndex(function (existing) { return savedAliases(existing).some(function (alias) { return aliases.indexOf(alias) > -1; }); });
        if (index < 0) output.push(record);
        else output[index] = Object.assign({}, record, output[index], {
          productGid: output[index].productGid || record.productGid || record.product_gid || null,
          product_gid: output[index].product_gid || record.product_gid || record.productGid || null,
          handle: output[index].handle || record.handle || '',
          code: output[index].code || record.code || '',
          title: output[index].title || record.title || '',
          url: output[index].url || record.url || '',
          image: output[index].image || record.image || ''
        });
      });
    });
    return output;
  }

  function union(primary, incoming, identity) {
    var output = [];
    var seen = Object.create(null);
    [primary, incoming].forEach(function (records) {
      (Array.isArray(records) ? records : []).forEach(function (record) {
        var key = identity(record);
        if (!key || seen[key]) return;
        seen[key] = true;
        output.push(record);
      });
    });
    return output;
  }

  function usedSpaces(items) {
    return (Array.isArray(items) ? items : []).reduce(function (sum, item) { var unit = Math.max(1, Number(item && item.spaces) || 1); var qty = Math.max(1, Math.floor(Number(item && item.quantity) || 1)); return sum + unit * qty; }, 0);
  }

  function operationId() {
    if (window.crypto && window.crypto.randomUUID) return 'merge-' + window.crypto.randomUUID();
    return 'merge-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function pendingRecord(id, guestId, snapshot) {
    return { operationId: id, type: 'guest-claim', guestId: guestId, status: 'pending', attempts: 0, createdAt: Date.now(), lastAttemptAt: 0, lastError: '', snapshot: snapshot };
  }

  function pendingGuestRecord(state, guestId) {
    var queue = state && Array.isArray(state.syncQueue) ? state.syncQueue : [];
    return queue.find(function (entry) {
      return entry && entry.guestId === guestId && (entry.status === 'pending' || entry.status === 'syncing');
    }) || null;
  }

  function updateSyncRecord(operation, values, reason) {
    if (!window.JPState) return false;
    return window.JPState.update(function (state) {
      state.syncQueue = Array.isArray(state.syncQueue) ? state.syncQueue : [];
      var index = state.syncQueue.findIndex(function (entry) { return entry && entry.operationId === operation; });
      if (index < 0) return state;
      state.syncQueue[index] = Object.assign({}, state.syncQueue[index], values || {});
      return state;
    }, reason || 'guest-sync-status');
  }

  async function synchronize(record) {
    if (!record || !record.operationId) throw new Error('The guest sync record is missing. The guest draft was not cleared.');
    updateSyncRecord(record.operationId, { status: 'syncing', attempts: Number(record.attempts || 0) + 1, lastAttemptAt: Date.now(), lastError: '' }, 'guest-sync-start');
    try {
      var result = await window.JPSavedDesigns.claimGuestSnapshot(record);
      updateSyncRecord(record.operationId, { status: 'synced', syncedAt: Date.now(), lastError: '', server: result }, 'guest-sync-success');
      return { synced: true, result: result };
    } catch (error) {
      updateSyncRecord(record.operationId, { status: 'pending', lastError: String(error && error.message || error), lastAttemptAt: Date.now() }, 'guest-sync-pending');
      return { synced: false, pending: true, error: error };
    }
  }

  async function retryPending() {
    if (!(window.JPIdentity && window.JPIdentity.isCustomer() && window.JPSavedDesigns && window.JPState)) return [];
    var queue = (window.JPState.read().syncQueue || []).filter(function (entry) { return entry && entry.guestId && entry.snapshot && entry.status === 'pending'; });
    var results = [];
    for (var index = 0; index < queue.length; index += 1) {
      var record = queue[index];
      var sync = await synchronize(record);
      var rotation = null;
      if (sync.synced && record.guestId === window.JPIdentity.getGuestId() && window.JPIdentity.guestOwner(record.guestId) === window.JPIdentity.customerId()) {
        rotation = window.JPIdentity.sealAndRotate(record.guestId, { operationId: record.operationId, syncStatus: 'synced', itemCount: (record.snapshot && record.snapshot.items || []).length, savedCount: (record.snapshot && record.snapshot.saved || []).length });
      }
      results.push({ operationId: record.operationId, synced: sync.synced, pending: !sync.synced, rotation: rotation, error: sync.error || null });
    }
    return results;
  }

  function merge() {
    if (mergePromise) return mergePromise;
    if (!(window.JPIdentity && window.JPIdentity.isCustomer() && window.JPState && window.JPSavedDesigns)) {
      return Promise.resolve({ merged: false, reason: 'guest' });
    }
    mergePromise = Promise.resolve().then(async function () {
      await window.JPSavedDesigns.init();
      var guestId = window.JPIdentity.getGuestId();
      var owner = window.JPIdentity.guestOwner(guestId);
      var customer = window.JPIdentity.customerId();
      if (owner && owner !== customer) return { merged: false, reason: 'owned-by-another-customer' };
      var guest = readJson(window.JPIdentity.guestStateKey(guestId), {});
      var guestSaved = readJson(window.JPIdentity.guestSavedKey(guestId), []);
      var current = window.JPState.read();
      var existingRecord = pendingGuestRecord(current, guestId);
      var customerItemCount = Array.isArray(current.items) ? current.items.length : 0;
      var incomingSaved = unionSaved(guest && guest.saved, guestSaved);
      var guestItems = Array.isArray(guest && guest.items) ? guest.items : [];
      if (!guestItems.length && !incomingSaved.length) {
        if (!existingRecord) return { merged: false, reason: 'empty-guest' };
        var recoveredSync = await synchronize(existingRecord);
        if (!recoveredSync.synced) {
          var recoveredPending = { merged: false, items: (current.items || []).length, saved: (current.saved || []).length, usedSpaces: usedSpaces(current.items), syncStatus: 'pending', pending: true, retryable: true, operationId: existingRecord.operationId, rotation: null, message: String(recoveredSync.error && recoveredSync.error.message || 'Account sync is pending.') };
          document.dispatchEvent(new CustomEvent('justpress:identity-merge-pending', { detail: recoveredPending }));
          return recoveredPending;
        }
        var recoveredRotation = window.JPIdentity.sealAndRotate(guestId, { operationId: existingRecord.operationId, syncStatus: 'synced', itemCount: (existingRecord.snapshot && existingRecord.snapshot.items || []).length, savedCount: (existingRecord.snapshot && existingRecord.snapshot.saved || []).length });
        var recovered = { merged: false, items: (current.items || []).length, saved: (current.saved || []).length, usedSpaces: usedSpaces(current.items), syncStatus: 'synced', pending: false, operationId: existingRecord.operationId, rotation: recoveredRotation, recovered: true };
        document.dispatchEvent(new CustomEvent('justpress:identity-merge-ready', { detail: recovered }));
        return recovered;
      }
      var mergedItems = union(current.items, guest && guest.items, itemIdentity);
      var mergedSaved = unionSaved(current.saved, incomingSaved);
      var spaces = usedSpaces(mergedItems);
      if (spaces > MAX_SPACES) {
        throw new Error('The merged set needs ' + spaces + ' Spaces; the maximum supported package is 72. No items were changed.');
      }

      var changed = mergedItems.length !== (current.items || []).length || mergedSaved.length !== (current.saved || []).length;
      var id = existingRecord ? existingRecord.operationId : operationId();
      var snapshot = { items: Array.isArray(guest.items) ? guest.items : [], saved: incomingSaved, currentItemId: guest.currentItemId || null, plan: guest.plan || 'starter' };
      current.items = mergedItems;
      current.saved = mergedSaved;
      current.syncQueue = Array.isArray(current.syncQueue) ? current.syncQueue : [];
      if (!existingRecord) current.syncQueue.push(pendingRecord(id, guestId, snapshot));
      if (!current.currentItemId && guest && guest.currentItemId && mergedItems.some(function (item) { return String(item.id) === String(guest.currentItemId); })) {
        current.currentItemId = String(guest.currentItemId);
      }
      if (customerItemCount === 0 && mergedItems.length && guest && guest.plan) current.plan = guest.plan;
      if (!window.JPState.write(current, 'guest-login-local-merge-pending')) throw new Error('The customer draft could not be written locally.');
      if (!window.JPIdentity.claimGuestForCurrentCustomer(guestId)) throw new Error('The guest draft could not be claimed for this customer.');

      var record = window.JPState.read().syncQueue.find(function (entry) { return entry.operationId === id; });
      var sync = await synchronize(record);
      if (!sync.synced) {
        var pending = { merged: changed, items: mergedItems.length, saved: mergedSaved.length, usedSpaces: spaces, syncStatus: 'pending', pending: true, retryable: true, operationId: id, rotation: null, message: String(sync.error && sync.error.message || 'Account sync is pending.') };
        document.dispatchEvent(new CustomEvent('justpress:identity-merge-pending', { detail: pending }));
        return pending;
      }
      var rotation = window.JPIdentity.sealAndRotate(guestId, { operationId: id, syncStatus: 'synced', itemCount: snapshot.items.length, savedCount: snapshot.saved.length });
      var result = { merged: changed, items: mergedItems.length, saved: mergedSaved.length, usedSpaces: spaces, syncStatus: 'synced', pending: false, operationId: id, rotation: rotation };
      document.dispatchEvent(new CustomEvent('justpress:identity-merge-ready', { detail: result }));
      return result;
    }).catch(function (error) {
      var detail = { merged: false, reason: 'merge-failed', message: String(error && error.message || error) };
      document.dispatchEvent(new CustomEvent('justpress:identity-merge-error', { detail: detail }));
      mergePromise = null;
      throw error;
    });
    mergePromise.then(function (result) { if (result && result.pending) mergePromise = null; }, function (error) {
      if (window.JPRuntime) window.JPRuntime.reportError(error, 'guest-merge');
    });
    return mergePromise;
  }

  window.JPAuthMerge = { init: merge, merge: merge, retryPending: retryPending, itemIdentity: itemIdentity, usedSpaces: usedSpaces };
  function startMerge() {
    merge().catch(function (error) {
      if (window.JPRuntime) window.JPRuntime.reportError(error, 'guest-merge-startup');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startMerge);
  else startMerge();
})();
